module.exports = __webpack_public_path__ + "img/syzn_01.831826e3.jpg";